import { render } from "./Profile.vue?vue&type=template&id=28d08332"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=28d08332&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28d08332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28d08332', __exports__)) {
    console.log('reload')
    api.reload('28d08332', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=28d08332", () => {
    console.log('re-render')
    api.rerender('28d08332', render)
  })

}


export default __exports__